import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const contactsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: keys,
    id: <U extends QueryKeyParam>(
      uuid: U // uuid here is the contact id
    ) =>
      createQueryKey({
        all: [...keys, uuid] as const,
        detail: [...keys, uuid, 'detail'] as const,
      }),
  });

export { contactsKeys };
